"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/SolidClock.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var SolidClock = function SolidClock(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "solid-icon",
    viewBox: "0 0 243.99 243.99"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Clock Icon"), _react2.default.createElement("path", {
    className: "solid-clock",
    d: "M122 0a122 122 0 1 0 122 122A122 122 0 0 0 122 0zm66.08 169.1a10.06 10.06 0 0 1-8.57 4.77 9.9 9.9 0 0 1-5.21-1.48l-58.68-36h.06a9.9 9.9 0 0 1-4.68-8.51V54a10 10 0 1 1 20 0v68.24l53.84 33.12a10 10 0 0 1 3.23 13.74z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }));
};
exports.default = SolidClock;